import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { LazyComponent } from "../../FundPages/core/LazyComponent";
import SecondaryNav from '../../FundPages/blocks/secondaryNav/SecondaryNav';

const ContentAreaBlock = React.lazy(() => import('../../FundPages/blocks/ContentAreaBlock'));
const HTMLBlock = React.lazy(() => import('../../FundPages/blocks/HtmlBlock'));
const HoldingsBlock = React.lazy(()=>import('../../FundPages/Components/HoldingsBlock/HoldingsBlock'))
const HistoPricesBlock = React.lazy(()=>import('../Components/HistoPricesBlock/HistoPricesBlock'))
const PerformanceHistoryBlock = React.lazy(()=>import('../Components/PerformanceHistoryBlock/PerformanceHistoryBlock'))
const HypotheticalChartBlock = React.lazy(()=>import('../../FundPages/Components/HypotheticalChartBlock/HypotheticalChartBlock'))
const EmptyComponent = React.lazy(() => import('../../FundPages/Components/EmptyComponent/EmptyComponent'))
const HoldingsWeightingsChartBlock = React.lazy(()=>import('../../FundPages/Components/HoldingsWeightingsChartblock/HoldingsWeightingsChartBlock'))
const TradingInformationBlock = React.lazy(()=> import('../Components/TradingInformationBlock/TradingInformationBlock'))
const PerformancePastYearsChartBlock = React.lazy(()=>import('../Components/PerformancePastYearsChartBlock/PerformancePastYearsChartBlock'))
const PerformanceScenarioHistoryBlock = React.lazy(()=> import('../Components/PerformanceScenarioHistoryBlock/PerformanceScenarioHistoryBlock'))
const FundDetailsBlock = React.lazy(() => import('../../FundPages/Components/FundDetailsBlock/FundDetailsBlock'))
const OneColumnUcitsBlock = React.lazy(()=> import('../Components/OneColumnUcitsBlock/OneColumnUcitsBlock'))
const NavDistributionsBlock = React.lazy(()=>import('../../FundPages/Components/NavDistributionsBlock/NavDistributionsBlock'))
const NavInformationBlock = React.lazy(()=> import('../Components/NavInformationBlock/NavInformationBlock'))
const IndexHoldingsBlock = React.lazy(()=> import('../../FundPages/Components/IndexHoldingsBlock/IndexHoldingsBlock'))
const GenericFundBlock = React.lazy(()=> import('../Components/GenericFundBlock/GenericFundBlock'))
const HoldingsCreditQualityBlock = React.lazy(()=>import('../../FundPages/Components/HoldingsCreditQualityBlock/HoldingsCreditQualityBlock'))
const IndexFundamentalsBlock = React.lazy(()=>import('../../FundPages/Components/IndexFundamentalsBlock/IndexFundamentalsBlock'))
const AnalyticsCustomBlock = React.lazy(()=>import('../../FundPages/Components/AnalyticsCustomBlock/AnalyticsCustomBlock'))
const ReferenceNavBlock = React.lazy(()=> import('../Components/ReferenceNavBlock/ReferenceNavBlock'))
const PersonUsBlock = React.lazy(() => import('../../FundPages/Components/PersonUsBlock/PersonUsBlock'))
const MultiColumnUcitsBlock = React.lazy(()=> import('../Components/MultiColumnUcitsBlock/MultiColumnUcitsBlock'))
const HoldingsWeightingsBlock = React.lazy(() => import('../../FundPages/Components/HoldingsWeightingsBlock/HoldingsWeightingsBlock'))
const DisclosureBlock = React.lazy(() => import('../../FundPages/blocks/DisclosureBlock'));
const ReferenceLinksBlock = React.lazy(() => import('../Components/ReferenceLinksBlock/ReferenceLinksBlock'));

//Bots
const isCrawler = /bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent);

const blockTypes = [
    {
        name: "SecondaryNav",
        tagName: "ve-fundpagesecondarynav",
        component: SecondaryNav,
        LoadImmediately: true
    },
    {
        name: "ContentAreaBlock",
        tagName: "ve-contentareablock",
        component: ContentAreaBlock,
        LoadImmediately: false
    },
    {
        name: "HTMLBlock",
        tagName: "ve-htmlblock",
        component: HTMLBlock,
        LoadImmediately: false,
        template: ""
    },
    {
        name: "HoldingsBlock",
        tagName: "ve-holdingsblock",
        component: HoldingsBlock,
        LoadImmediately: false
    },
    {
        name: "IndexHoldingsBlock",
        tagName: "ve-indexholdingsblock",
        component: IndexHoldingsBlock,
        LoadImmediately: false
    },
    {
        name: "HistoPricesBlock",
        tagName: "ve-histopricesblock",
        component: HistoPricesBlock,
        LoadImmediately: false
    },
    {
        name: "PerformanceHistoryBlock",
        tagName: "ve-performancehistoryblock",
        component: PerformanceHistoryBlock,
        LoadImmediately: false
    },
    {
        name: "HypotheticalChartBlock",
        tagName: "ve-hypotheticalchartblock",
        component: HypotheticalChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "HoldindsWeightingsChartBlock",
        tagName: "ve-holdingsweightingschartblock",
        component: HoldingsWeightingsChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "TradingInformationBlock",
        tagName: "ve-tradinginformationblock",
        component: TradingInformationBlock,
        LoadImmediately: false
    },
    {
        name: "PerformanceScenarioHistoryBlock",
        tagName: "ve-performancescenariohistoryblock",
        component: PerformanceScenarioHistoryBlock,
        LoadImmediately: false
    },
    {
        name: "PerformancePastYearsChartBlock",
        tagName: "ve-performancepastyearschartblock",
        component: PerformancePastYearsChartBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "FundDetailsBlock",
        tagName: "ve-fund-details-block",
        component: FundDetailsBlock,
        LoadImmediately: false
    },
    {
        name: "OneColumnUcitsBlock",
        tagName: "ve-onecolumnucitsblock",
        component: OneColumnUcitsBlock,
        LoadImmediately: false,
        IgnoreForCrawlers: true
    },
    {
        name: "NavDistributionsBlock",
        tagName: "ve-navdistributionsblock",
        component: NavDistributionsBlock,
        LoadImmediately: false
    },
    {
        name: "NavInformationBlock",
        tagName: "ve-navinformationblock",
        component: NavInformationBlock,
        LoadImmediately: false
    },
    {
        name: "GenericFundBlock",
        tagName: "ve-generic-fund-info-block",
        component: GenericFundBlock,
        LoadImmediately: false
    },
    {
        name: "HoldingsCreditQualityBlock",
        tagName: "ve-holdingscreditqualityblock",
        component: HoldingsCreditQualityBlock,
        LoadImmediately: false
    },
    {
        name: "IndexFundamentalsBlock",
        tagName: "ve-indexfundamentalsblock",
        component: IndexFundamentalsBlock,
        LoadImmediately: false
    },
    {
        name: "AnalyticsCustomBlock",
        tagName: "ve-analyticscustomblock",
        component: AnalyticsCustomBlock,
        LoadImmediately: false
    },
    {
        name: "ReferenceNavBlock",
        tagName: "ve-referencenavblock",
        component: ReferenceNavBlock,
        LoadImmediately: false
    },
    {
        name: "MultiColumnUcitsBlock",
        tagName: "ve-multicolumnucitsblock",
        component: MultiColumnUcitsBlock,
        LoadImmediately: false
    },
    {
        name: "PersonUsBlock",
        tagName: "ve-contentareablock",
        component: PersonUsBlock,
        LoadImmediately: false,
        template: "PersonUsBlocks",
        IgnoreForCrawlers: true
    },
    {
        name: "HoldingsWeightingsBlock",
        tagName: "ve-holdingsweightingsblock",
        component: HoldingsWeightingsBlock,
        LoadImmediately: false
    },
    {
        name: "DisclosureBlock",
        tagName: "ve-disclosureblock",
        component: DisclosureBlock,
        LoadImmediately: false
    },
    {
        name: "EmptyComponent",
        tagName: "ve-emptycomponent",
        component: EmptyComponent,
        LoadImmediately: false
    },
    {
        name: "ReferenceLinksBlock",
        tagName: "ve-referencelinksblock",
        component: ReferenceLinksBlock,
        LoadImmediately: false
    }
]

export function processMarkup(rootElem = document) {
    //If it is a crawler, remove the blocks that are too slow to load.
    let blockTypesToRender = blockTypes;
    if (isCrawler) {
        blockTypesToRender = blockTypes.filter(block => {
            return typeof(block.IgnoreForCrawlers) == "undefined" || block.IgnoreForCrawlers == false;
        })
    }

    for (const block of blockTypesToRender) {
        var containers = rootElem.getElementsByTagName(block.tagName)
        if (block.template != null) {
            containers = Array.from(containers).filter(x => x.dataset.template == block.template)
        }
        for (const container of containers) {
            const root = createRoot(container);
            const { component, LoadImmediately } = block;
            root.render(
                <Suspense fallback={<div className="component-loading">Loading...</div>}>
                    <LazyComponent component={component} rootElement={container} loadImmediately={LoadImmediately} />
                </Suspense>
            );
        }
    }
}
